module.exports = __webpack_public_path__ + "static/img/support_2.82576e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/support_2.png
// module id = Jerv
// module chunks = 0